var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackslash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 1.37518C9.73377 1.36733 8.47865 1.61093 7.30734 2.09185C6.13604 2.57277 5.07187 3.28145 4.17654 4.17678C3.2812 5.07211 2.57253 6.13628 2.09161 7.30759C1.61069 8.47889 1.36709 9.73402 1.37494 11.0002C1.36709 12.2664 1.61069 13.5215 2.09161 14.6928C2.57253 15.8641 3.2812 16.9283 4.17654 17.8236C5.07187 18.7189 6.13604 19.4276 7.30734 19.9085C8.47865 20.3894 9.73377 20.633 10.9999 20.6252C12.2661 20.633 13.5212 20.3894 14.6925 19.9085C15.8638 19.4276 16.928 18.7189 17.8233 17.8236C18.7187 16.9283 19.4274 15.8641 19.9083 14.6928C20.3892 13.5215 20.6328 12.2664 20.6249 11.0002C20.6328 9.73402 20.3892 8.47889 19.9083 7.30759C19.4274 6.13628 18.7187 5.07211 17.8233 4.17678C16.928 3.28145 15.8638 2.57277 14.6925 2.09185C13.5212 1.61093 12.2661 1.36733 10.9999 1.37518ZM14.7433 15.8127L6.18744 7.25723L7.25698 6.18768L15.8124 14.7435L14.7433 15.8127Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackslash);
export default __webpack_public_path__ + "static/media/ic-backslash.b69b5ead01e3865377489407a05926b3.svg";
export { ForwardRef as ReactComponent };